import { TextField } from '@material-ui/core';
import { isFunction } from 'lodash-es';
import React from 'react';
import { TimePickerProps } from './model';
import { Picker } from './Picker';
import { _24HourToAmPm } from './utils';

export const TimeTextField = ({ value = '', onChange, placeholder = `Time Picker` }: TimePickerProps) => {
  const [innerValue, setInnerValue] = React.useState<string>(value);
  const [openPicker, setOpenPicker] = React.useState<EventTarget | null>(null);
  const containerRef = React.useRef(null);

  const viewValue = _24HourToAmPm(innerValue || value).timeString;
  const handleClosePicker = (pickerValue: string) => {
    isFunction(onChange) && onChange(pickerValue);
    setInnerValue(pickerValue);
    setOpenPicker(null);
  };

  return (
    <div ref={containerRef}>
      <TextField
        value={viewValue}
        placeholder={placeholder}
        fullWidth
        variant='outlined'
        onClick={(e) => setOpenPicker(e.currentTarget)}
        InputProps={{
          readOnly: true,
          className: 'swyft-input'
        }}
        size='small'
      />
      <Picker
        width={(containerRef.current as any)?.offsetWidth}
        open={openPicker}
        handleClose={handleClosePicker}
        initData={_24HourToAmPm(innerValue || value)}
      />
    </div>
  );
};
